"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsGridView2 = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const FluidGrid_1 = require("../../FluidGrid");
const productTile_1 = require("../../productTile");
function ProductsGridView2({ onLoadMore, loading, products = [], productTile: ProductTile = productTile_1.ProductTileView2, }) {
    return ((0, jsx_runtime_1.jsx)(FluidGrid_1.FluidGridView, { data: products !== null && products !== void 0 ? products : [], element: (product) => (0, jsx_runtime_1.jsx)(ProductTile, { product: product }), select: () => null, onLoadMore: onLoadMore, loading: loading }));
}
exports.ProductsGridView2 = ProductsGridView2;
